import templateStr from 'text!./templates/additional-named-insured.html';

export default (function () {
    return {
        scope: {
            label: '@?',
            readonly: '=?',
            model: '=',
            hideInputLabel: '<?',
            explicitErrorMessage: '@?',
            insuredData: '=?',
            cancelAction: '&',
            changeAction: '&',
            insuredIndex: '=?'
        },
        template: templateStr,

        controller: ['$scope', 'LocaleService', 'ViewModelService', function ($scope, LocaleService, ViewModelService) {
            if ($scope.insuredIndex != null) {
                $scope.accountHolderView = $scope.insuredData.baseData.additionalNamedInsured[$scope.insuredIndex];
            } else {

                $scope.additionalNamedInsuredSubmission = {
                    contactName: '',
                    primaryAddress: { country: "US", state: "MT" },
                    primaryPhoneType: 'mobile',
                    subtype: 'Company'
                    /*mSFOfficialID_EXT: {
                    	aspects:{
                        inputCtrlType: "text",
                                 required: true,
                                 visible: true,
                                 get validationMessages() {
                                     //return [$filter('translate')('gateway.views.new-quote.errors.This is a required field')];
                                 	return ['This is a required field']
                                 },
                                 get valid() {
                                     return $scope.accountHolderView.mSFOfficialID_EXT.value.value;
                                 },
                                 
                    },
                    value: ''
                    }	*/
                };
                $scope.accountHolderView = ViewModelService.create($scope.additionalNamedInsuredSubmission, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO', {});
                /*$scope.accountHolderView.mSFOfficialID_EXT = {
                		aspects : {
                			inputCtrlType: "text",
                               required: true,
                               visible: true,
                               get validationMessages() {
                                   //return [$filter('translate')('gateway.views.new-quote.errors.This is a required field')];
                                   return ['This is a required field'];
                               },
                               get valid() {
                                   return $scope.accountHolderView.mSFOfficialID_EXT.value;
                               },
                		},
                               value: ''
                         
                       };
                */
                $scope.accountHolderView.primaryInsuredRelationship = {
                    aspects: {
                        inputCtrlType: "text",
                        required: false,
                        visible: true,
                        valid: true
                    },
                    value: ''
                };

                //Assigning Primary phone type
                $scope.accountHolderView.primaryPhoneType = 'mobile';
            }

            $scope.accountHolderView.subtype.aspects.availableValues = [{ code: 'Company' }, { code: 'Person' }];

            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9') + ' x ?9?9?9?9';
            $scope.phoneMaskWithoutExt = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');

            /**
             * Phone types
             */
            $scope.phoneTypes = {
                work: _.find($scope.accountHolderView.primaryPhoneType.aspects.availableValues, {
                    code: 'work'
                }),
                mobile: _.find($scope.accountHolderView.primaryPhoneType.aspects.availableValues, {
                    code: 'mobile'
                })
            };
            $scope.submitAddInsuredForm = function (addInsuredForm) {
                addInsuredForm.submitted = true;
                if (addInsuredForm.invalid) {
                    return;
                }

                $scope.changeAction({ data: { namedInsuredData: $scope.accountHolderView, namedInsuredIndex: $scope.insuredIndex } });
            };
        }]

    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/directives/additionalNamedInsured.js
// module id = 1306
// module chunks = 0